export { default as ColorsInterface } from './colorsInterface'



// WEBPACK FOOTER //
// ./src/modules/productTile/colorPicker/index.js